const useFlashMessages = () => {
    let flashMessages = null;
    const lsFlashMessages = localStorage.getItem("spedizioniweb2_flashMessages");



    if(lsFlashMessages !== null){
        let fm = JSON.parse(lsFlashMessages);        

        let fmpage = null;

        const idPagesInvolved = Object.keys(fm ?? {}).map(Number);

        let pagesInvolved = null;
        if(Array.isArray(idPagesInvolved) && idPagesInvolved.length){
            pagesInvolved = spedizioniweb2
                .paginearticoli
                .filter(p => idPagesInvolved.includes(Number(p.ID)))
                .reduce((obj, p) => ({
                    ...obj,
                    [p.ID]: p
                }), {});

            
        }

        const currentPageWithError = Object.values(pagesInvolved)
            .find(p => p.guid.includes(location.href)  || p.permalink.includes(location.href) )

        if(currentPageWithError !== undefined){
            fmpage = fm[currentPageWithError.ID];
        }

        if(Array.isArray(fmpage) && fmpage.length){
            flashMessages = [...fmpage];              
            eliminaMessaggiUtilizzati(fm, currentPageWithError.ID)            
        }

        const messaggiGenerici = fm["*"];

        if(Array.isArray(messaggiGenerici) && messaggiGenerici.length){
            flashMessages = [...(flashMessages ?? []), ...messaggiGenerici];              
            eliminaMessaggiUtilizzati(fm, "*")            
        }

    }


    return flashMessages;

}

const eliminaMessaggiUtilizzati = (messaggi, id) => {
    delete messaggi[id];        
    localStorage.setItem("spedizioniweb2_flashMessages", JSON.stringify(messaggi))        
    if(Object.keys(messaggi).length < 1){
        localStorage.removeItem("spedizioniweb2_flashMessages")
    }
}

const raggruppaMessaggiPerTipo = (messaggi) => {
    return (messaggi ?? [])
        .reduce((obj, m) => ({
            ...obj, 
            [m.tipo]: [...(obj?.[m.tipo] ?? []), m]
        }), {})
}

const aggiungiFlashMessage = (messaggio, id = "*") => {
    let allMessages = localStorage.getItem("spedizioniweb2_flashMessages");
    
    if(allMessages !== null){
        let allMessages = JSON.parse(allMessages);
    }

    allMessages[id] = [...allMessages[id], messaggio];

    localStorage.setItem("spedizioniweb2_flashMessages", JSON.stringify(allMessages));


}

export default useFlashMessages;
export {raggruppaMessaggiPerTipo, aggiungiFlashMessage};